import { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import getStartedImage from "../assets/svg/getStartedPage.svg";
import buttoonIcon from "../assets/svg/button.svg";
import buttonIcon2 from "../assets/svg/button1.svg";
import { clsfy } from "../helpers";
import Checkbox from "../components/utils/Checkbox/Checkbox";

const DocumentCard = ({ active, onChangeActive }) => {
	return (
		<div className={clsfy("bg-white p-4 h-56 flex flex-col relative border transition-all duration-500", [
			active ? 'border-ef' : 'border-e1'
		])}>
			<Checkbox className='absolute right-4' value={active} onChange={onChangeActive} />
			<div className="font-bold">Early Life</div>
			<div className="text-xs flex-1 overflow-hidden">
				Lorem ipsum dolor sit amet, consectetur adipisicing elit.
				Architecto mollitia nam ut eveniet illo perferendis dicta placeat
				rem libero cumque voluptas quaerat, veniam illum excepturi ipsa.
				Ratione excepturi animi pariatur. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ex dolorem debitis magnam facere eius tempore earum illum eligendi doloribus qui nemo tempora delectus sapiente iure culpa ipsam nisi vero rerum beatae, nesciunt placeat maxime accusamus. Mollitia eius adipisci natus ipsum, ut, consequuntur aut veritatis magni consectetur saepe cumque id. Quas voluptatem fugiat
			</div>
			<div className={clsfy("absolute inset-x-0 bottom-0 z-10 px-4 py-3 border-t border-e1 text-556 transition-all duration-500", [
				active ? 'bg-ef text-white' : 'bg-white text-black'
			])}>
				<div className='flex items-center'>
					<i className="mdi mdi-text-box-outline text-xl"></i>
					<span className="text-base leading-3">
						Oliver Winchester
					</span>
				</div>
				<span className={clsfy("text-sm transition-all duration-500", [active ? 'text-white' : 'text-7d'])}>27 nov.2019</span>
				<button className="absolute right-5 top-1/2 transform -translate-y-1/2">
					<i className="mdi mdi-dots-vertical text-xl"></i>
				</button>
			</div>
		</div>
	)
}

const Dashboard = () => {

	const [activeEditing, setActiveEditing] = useState(1)
	const [editings] = useState([
		{ id: 1 }, { id: 2 },
		{ id: 3 }, { id: 4 },
	])

	const isActive = id => activeEditing === id
	const handleChangeActive = (id) => {
		setActiveEditing(id)
		// if (isActive(id)) {
		// 	return setActiveEditings(v => v.filter(v => v !== id))
		// }
		// return setActiveEditings(v => v.concat(id))
	}

	return (
		<Fragment>
			<div className="bg-white pl-9 pt-5 flex items-center w-full">
				<div>
					<span className="text-xl text-gray-500 font-bold">Get Started</span>{" "}
					<br />
					<p>
						{" "}
						Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cum maxime
						obcaecati animi, delectus velit nihil ipsam rerum voluptate
						quibusdam nobis dolorum consequatur in quaerat ducimus, odio ut,
						recusandae error illum.
					</p>
					<Link
						to="/editor"
						className="mt-4 w-48 h-12 bg-ef text-white font-bold py-2 px-4 mb-6 lg:mb-12 inline-flex items-center rounded-lg"
					>
						<span className="mdi mdi-plus text-2xl pr-3" />
						<span className="text-base font-bold">New Document</span>
					</Link>
				</div>

				<img className="w-5/12 mx-2" src={getStartedImage} alt="" />
			</div>
			<div className="text-gray-500 py-4 md:pb-4 md:pt-8 px-1">
				<span className="text-xl font-extrabold">Recent Documents</span>
			</div>
			<div className="flex space-x-2 text-2px">
				<div className="bg-white w-139  h-24 relative border-2  border-e1 overflow-hidden">
					<div className=" relative px-2 pt-1">
						<span className="text-xxs font-bold">Career</span>
						<div className="text-2px pt-1 overflow-hidden  ">
							Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet
							rerum, animi id commodi ipsa maxime numquam quo et. Ratione
							dignissimos cum illum. Aliquid laboriosam fuga ipsa. Sunt libero
							delectus modi? Lorem ipsum dolor sit amet consectetur, adipisicing
							elit. Eveniet rerum, animi id commodi ipsa maxime numquam quo et.
							Ratione dignissimos cum illum. Aliquid laboriosam fuga ipsa. Sunt
							libero delectus modi? Lorem ipsum dolor sit amet consectetur,
							adipisicing elit. Eveniet rerum, animi id commodi ipsa maxime
							numquam quo et. Ratione dignissimos cum illum. Aliquid laboriosam
							fuga ipsa. Sunt libero delectus modi? Lorem ipsum dolor sit amet
							consectetur, adipisicing elit. Eveniet rerum, animi id commodi
							ipsa maxime numquam quo et. Ratione dignissimos cum illum. Aliquid
							laboriosam fuga ipsa. Sunt libero delectus modi?
						</div>
						<div className="flex justify-between items-center absolute inset-x-0 bottom-0 px-2  bg-white text-556  font-bold">
							<div className="text-xs">
								<span>Oliver Winn...</span>
							</div>
							<div>
								<div className="my-auto">
									<span className="mdi mdi-dots-vertical text-sm"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="bg-white w-139  h-24 relative border-2  border-e1 overflow-hidden">
					<div className=" relative px-2 pt-1">
						<span className="text-xxs font-bold">Early life</span>
						<div className="text-2px pt-1 overflow-hidden  ">
							Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet
							rerum, animi id commodi ipsa maxime numquam quo et. Ratione
							dignissimos cum illum. Aliquid laboriosam fuga ipsa. Sunt libero
							delectus modi? Lorem ipsum dolor sit amet consectetur, adipisicing
							elit. Eveniet rerum, animi id commodi ipsa maxime numquam quo et.
							Ratione dignissimos cum illum. Aliquid laboriosam fuga ipsa. Sunt
							libero delectus modi? Lorem ipsum dolor sit amet consectetur,
							adipisicing elit. Eveniet rerum, animi id commodi ipsa maxime
							numquam quo et. Ratione dignissimos cum illum. Aliquid laboriosam
							fuga ipsa. Sunt libero delectus modi? Lorem ipsum dolor sit amet
							consectetur, adipisicing elit. Eveniet rerum, animi id commodi
							ipsa maxime numquam quo et. Ratione dignissimos cum illum. Aliquid
							laboriosam fuga ipsa. Sunt libero delectus modi?
						</div>
						<div className="flex justify-between items-center absolute inset-x-0 bottom-0 px-2  bg-white text-556  font-bold">
							<div className="text-xs">
								<span>Oliver Winn...</span>
							</div>
							<div>
								<div className="my-auto">
									<span className="mdi mdi-dots-vertical text-sm"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="bg-white w-139  h-24 relative border-2  border-e1  overflow-hidden">
					<div className=" relative px-2 pt-1">
						<span className="text-xxs font-bold">Rober Guillaume</span>
						<div className="text-2px pt-1 overflow-hidden  ">
							Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet
							rerum, animi id commodi ipsa maxime numquam quo et. Ratione
							dignissimos cum illum. Aliquid laboriosam fuga ipsa. Sunt libero
							delectus modi? Lorem ipsum dolor sit amet consectetur, adipisicing
							elit. Eveniet rerum, animi id commodi ipsa maxime numquam quo et.
							Ratione dignissimos cum illum. Aliquid laboriosam fuga ipsa. Sunt
							libero delectus modi? Lorem ipsum dolor sit amet consectetur,
							adipisicing elit. Eveniet rerum, animi id commodi ipsa maxime
							numquam quo et. Ratione dignissimos cum illum. Aliquid laboriosam
							fuga ipsa. Sunt libero delectus modi? Lorem ipsum dolor sit amet
							consectetur, adipisicing elit. Eveniet rerum, animi id commodi
							ipsa maxime numquam quo et. Ratione dignissimos cum illum. Aliquid
							laboriosam fuga ipsa. Sunt libero delectus modi?
						</div>
						<div className="flex justify-between items-center absolute inset-x-0 bottom-0 px-2  bg-white text-556  font-bold">
							<div className="text-xs">
								<span>Oliver Winn...</span>
							</div>
							<div>
								<div className="my-auto">
									<span className="mdi mdi-dots-vertical text-sm"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="text-gray-500 py-4 md:pb-4 md:pt-8 px-1">
				<span className="text-xl font-extrabold">Continue Editing</span>
				<br />
				<span className="text-sm">
					Lorem ipsum, dolor sit amet consectetur adipisicing elit.
				</span>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
				{editings.map(editing => (
					<DocumentCard
						key={editing.id}
						active={isActive(editing.id)}
						onChangeActive={v => handleChangeActive(editing.id, v)}
					/>
				))}
			</div>

			<div className="absolute right-8 top-8 sm:top-10 lg:top-12 flex space-x-2">
				<button className="bg-ef bg-opacity-25 hover:bg-gray-400 text-gray-800 font-bold py-2 px-2 rounded inline-flex items-center">
					<img className="object-fill w-5 h-4" src={buttoonIcon} alt='' />
				</button>
				<button className=" hover:bg-gray-400 text-gray-800 font-bold py-2 px-2 rounded inline-flex items-center">
					<img className="object-fill w-5 h-4" src={buttonIcon2} alt='' />
				</button>
			</div>
		</Fragment>
	);
};

export default Dashboard;